import React from 'react';
import { Button, ButtonProps } from './Button';

export interface IconButtonProps extends Omit<ButtonProps, 'size'> {
  'aria-label': string;
}

/**
 * Icon-only action button (h-8 w-8) - replaces emoji glyphs (🔍⏰✕▶✓) and
 * fixed-width text pills (e.g. w-28 h-8 "▶ Proceed") used as row actions.
 * aria-label is required, not optional, since there's no visible text.
 */
export const IconButton: React.FC<IconButtonProps> = ({ variant = 'ghost', ...props }) => {
  return <Button variant={variant} size="icon" {...props} />;
};
